import Axios from "axios";
import token from "./setToken";

export default {
  async search(searchCondition) {
    let params = new URLSearchParams();
    params.append('searchCondition', JSON.stringify(searchCondition));
 
    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantList", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査を取得できません[search]");
      throw error;
    }
  },

  async getData(companyId, targetYear) {
    try {
      // await token.checkToken();
      const res = await Axios.get("/api/Refrigerant/" + companyId + "/" + targetYear, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査一覧を取得できません[getData]");
      throw error;
    }
  },

  async sendAnswer(companyId) {
    try {
      // await token.checkToken();
      const res = await Axios.post("/api/Refrigerant/" + companyId, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("回答を送信できません[sendAnswer]");
      throw error;
    }
  },

  async setRefrigerantData(mailData, mailDestArray, refrigerantData, attachment, mode) {
 
    let params = new FormData();
    params.append('mailData', JSON.stringify(mailData));
    params.append('mailDestArray', JSON.stringify(mailDestArray));
    params.append('refrigerantData', JSON.stringify(refrigerantData));
    // ファイル
    for(let i=0; i < attachment.length; i++) {
      params.append('attachment['+i+']', attachment[i]);
    }
    params.append('mode', mode);
 
    try {
      // await token.checkToken();
      const res = await Axios.post('/api/Refrigerant', params, token.setTokenToHeader());
      return res;
 
    } catch (error) {
      console.error("冷媒調査を設定できません");
      throw error;
    }
  },

  async getSurveyAnsStatus(searchCondition) {
    let params = new URLSearchParams();
    params.append('searchCondition', JSON.stringify(searchCondition));

    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantAnsStatus", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査を取得できません[getSurveyAnsStatus]");
      throw error;
    }
  },

  /** 調査取得 */
  async getExistSurvey(targetYear) {
    let params = new URLSearchParams();
    params.append('targetYear', JSON.stringify(targetYear));

    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantExistSurvey", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査を取得できません[getExistSurvey]");
      throw error;
    }
  },

  /** 冷媒調査集計 */
  async sumRefrigerantDB(searchCondition) {
    let params = new URLSearchParams();
    params.append('searchCondition', JSON.stringify(searchCondition));

    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantSumDB", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査集計を作成できません[sumRefrigerantDB]");
      throw error;
    }
  },
};
